import type { FC } from 'react';

import type { IconProps } from './types';

const BlockNumberedList: FC<IconProps> = ({ color = 'currentColor', ...props }) => (
  <svg width="24" height="24" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M192 128.001c0 53.02-42.98 96-96 96s-96-42.98-96-96 42.98-96 96-96 96 42.98 96 96zM362.666 160h618.667c23.565 0 42.667-14.326 42.667-32s-19.102-32-42.667-32H362.666C339.102 96 320 110.326 320 128s19.102 32 42.666 32zM192 512c0 53.022-42.98 96-96 96S0 565.022 0 512s42.98-96 96-96 96 42.978 96 96zm789.332-32H362.665c-23.564 0-42.666 14.327-42.666 32s19.102 32 42.666 32h618.667c23.565 0 42.667-14.327 42.667-32s-19.102-32-42.667-32zM192 895.999c0 53.022-42.98 96-96 96s-96-42.978-96-96 42.98-96 96-96 96 42.978 96 96zm789.332-32H362.665c-23.564 0-42.666 14.327-42.666 32 0 17.677 19.102 32 42.666 32h618.667c23.565 0 42.667-14.323 42.667-32 0-17.673-19.102-32-42.667-32z"
      fill={color}
    />
  </svg>
);

export default BlockNumberedList;
